<script setup lang="ts">
import PuzzleChallengeIcon from '@/assets/images/puzzle-challenge-icon.webp'
import PuzzleStar from '@/assets/images/carousel-banners/puzzle-challenge-button-star.webp'
import { usePuzzleChallenge } from '@/composables/game/challenges'

const { isPuzzleChallengeLive, countdown, formattedCountdown } = usePuzzleChallenge()

</script>

<template>
  <div
    v-if="isPuzzleChallengeLive"
    class="flex flex-col items-center justify-center"
  >
    <div class="bg-puzzles-container bg-puzzles-gradient relative flex items-center justify-center size-12 rounded-[15px] p-0.5">
      <img
        class="size-[80px] absolute object-cover -bottom-5"
        :src="PuzzleChallengeIcon"
        alt="Puzzle Challenge Icon"
      >
      <img
        class="absolute left-3 h-[25%] z-[2] top-0"
        :src="PuzzleStar"
      >
      <img
        class="absolute left-0.5 h-[25%] z-[2] top-3 rotate-[45deg]"
        :src="PuzzleStar"
      >
    </div>
    <div class="z-[10] flex flex-col -mt-2 items-center">
      <div class="z-[1] whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-tropee-black">
        Challenge
      </div>
      <div
        class="z-[2] -mt-1 whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] tabular-nums"
        :class="countdown < (3600 * 3) ? 'text-red-danger' : 'text-tropee-black'"
      >
        {{ formattedCountdown }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-puzzles-container {
  background: #FFF246;
}

.bg-puzzles-gradient {
  background: linear-gradient(138deg, #EE1F41 8.33%, #5A7E9F 47.19%)
}
</style>